import styles from "./Containers.module.css";

const CenterCard = ({ children }) => {
  return <div className={styles.centerCard}>{children}</div>;
};

export default CenterCard;
